module.exports = __webpack_public_path__ + "img/t3-5.c479937b.jpg";